"use client";
// components/ServicesMenu.tsx
import MegamenuIcn from "@/../public/assets/images/Megamenu-icn.svg";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import { Service } from "@/app/shared/type";
import { API_BASE_URL, USE_BACKEND } from "@/app/api/variable";
import axios from "axios";
import servicesData from "@/app/data/service.json";

export default function ServicesMenu() {
  const [services, setServices] = useState<Service[]>([]);
  const [loading, setLoading] = useState(true);
  const CDN_BASE_URL = "https://assets.nimbusnode.dev"; // Replace with your CDN URL

  useEffect(() => {
    const fetchServices = async () => {
      try {
        if (USE_BACKEND) {
          const response = await axios.get<Service[]>(`${API_BASE_URL}/service`);
          setServices(response.data);
        } else {
          setServices(servicesData as Service[]);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) {
    return (
      <div className="dropdown-services absolute left-0 top-full mt-2">
        <div className="bg-white p-8">
          <div className="megamenu-sec grid grid-cols-2 gap-8">
            {[...Array(9)].map((_, index) => (
              <div key={index} className="megamenu-item animate-pulse">
                <div className="h-6 bg-gray-200 rounded mb-2"></div>
                <ul className="ml-6 mt-2 space-y-2">
                  {[...Array(4)].map((_, idx) => (
                    <li key={idx}>
                      <div className="h-4 bg-gray-200 rounded"></div>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dropdown-services absolute left-0 top-full mt-2">
      <div className="bg-white p-8 desk-service-menu">
        {/* Grid */}
        <div className="megamenu-sec grid grid-cols-2 gap-8">
          {services.map((service, index) => {
          const imageUrl = service.icon
            ? `${CDN_BASE_URL}/${service.icon}`
            : "/assets/images/service-icon1.png";
            return (
              <div key={service.slug} className="megamenu-item">
                {/* Heading */}
                <Link href={`/services#${service.slug}`}
                  className="text-gray-600 hover:text-cyan-600 transition-colors"
                >
                  <h3 className="menu-item flex gap-[8px] items-start font-semibold">
                    <Image
                      src={imageUrl}
                      alt="service icon"
                      style={{ filter: "invert(1) sepia(1) saturate(5) hue-rotate(200deg)" }}
                      width={20}
                      height={20}
                    />
                    {service.name}
                  </h3>
                </Link>

                {/* Items */}
                <ul className="submenu ml-6 mt-2 space-y-2">
                  {service.subServices.map((subService, idx) => (
                    <li key={subService.slug || idx}>
                      <Link
                        href={`/services?sub=${subService.slug || idx}#${service.slug}`}
                        className="text-gray-600 hover:text-cyan-600 transition-colors"
                      >
                        {subService.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
